// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"61":"ba46556b","151":"45aae81d","569":"cb6efa4e","852":"06238818"}[chunkId] + ".chunk.js";
};